import {useEffect} from 'react';
import {useAuthStore} from '@/store/useAuthStore';
import {fetchUserInfo} from '@/services';

/**
 * 应用初始化时检测用户登录状态
 */
export const useInitUserInfo = () => {
    const setIsLogin = useAuthStore((s) => s.setIsLogin);
    const setUserInfo = useAuthStore((s) => s.setUserInfo);
    const setInitialized = useAuthStore((s) => s.setInitialized);

    useEffect(() => {
        const initUser = async () => {
            try {
                const res = await fetchUserInfo();

                // stoken 授权跳转
                if (res.stokenInfo.stokenAuthFlag && res.stokenInfo.stokenAuthUrl) {
                    window.location.href = res.stokenInfo.stokenAuthUrl;
                    return;
                }

                setIsLogin(true);
                setUserInfo(res.userInfo);
            } catch {
                setIsLogin(false);
                setUserInfo(null);
            }

            setInitialized();
        };

        void initUser();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
